import axios from "axios";
import config from "@Config/index";
import { SmartSearchRequest, SmartSearchResponse } from "./types";

/**
 * Calls the NLP Smart Search API to extract structured filters from natural language input.
 *
 * Base URL: config.COMMUNICATION_SERVICE_URL
 * Endpoint: POST /api/nlp/smart_search
 */
const smartSearchApi = async (
  payload: SmartSearchRequest,
  signal?: AbortSignal,
): Promise<SmartSearchResponse> => {
  const cancelToken = signal
    ? new axios.CancelToken((cancel) => {
        signal.addEventListener("abort", () => cancel("Request aborted"));
      })
    : undefined;

  const response = await axios.post(
    `${config.COMMUNICATION_SERVICE_URL}/api/nlp/smart_search`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
      timeout: 30000,
    },
  );

  return response.data;
};

export default smartSearchApi;
